import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './store'
// SPESİYAL
import SayfaYok from './pages/spesiyal/SayfaYok'
import Yetkisiz from './pages/spesiyal/Yetkisiz'
// GİRİŞ
import GirisRoute from './pages/Giris/_route'
import GirisIndex from './pages/Giris/index'
import GirisHesap from './pages/Giris/hesap'
import GirisParola from './pages/Giris/parola'
import GirisSifirla from './pages/Giris/sifirla'
import GirisOnay from './pages/Giris/onay'
// PANEL
import Panel from './pages/Panel/index'
// YÖNETİM
import YonetimRoute from './pages/Yonetim/_route'
import YonetimIndex from './pages/Yonetim/index'

import YonetimSirketRoute from './pages/Yonetim/sirket'
import YonetimSirketIndex from './pages/Yonetim/sirket/Index'
import YonetimSirketTeklif from './pages/Yonetim/sirket/Teklif'
import YonetimSirketMeskenTuru from './pages/Yonetim/sirket/MeskenTuru'

import YonetimBinaRoute from './pages/Yonetim/bina'
import YonetimBinaListe from './pages/Yonetim/bina/Liste'
import YonetimBinaDetay from './pages/Yonetim/bina/Detay'

import YonetimMeskenRoute from './pages/Yonetim/mesken'
import YonetimMeskenListe from './pages/Yonetim/mesken/Liste'
import YonetimMeskenDetay from './pages/Yonetim/mesken/Detay'

import YonetimKisiRoute from './pages/Yonetim/kisi'
import YonetimKisiListe from './pages/Yonetim/kisi/Liste'
import YonetimKisiDetay from './pages/Yonetim/kisi/Detay'
// MUHASEBE
import MuhasebeRoute from './pages/Muhasebe/_route'
import MuhasebeIndex from './pages/Muhasebe/index'
import MuhasebeCariRoute from './pages/Muhasebe/cari'
import MuhasebeCariListe from './pages/Muhasebe/cari/Liste'
import MuhasebeCariDetay from './pages/Muhasebe/cari/Detay'
import MuhasebePersonelRoute from './pages/Muhasebe/personel'
import MuhasebePersonelListe from './pages/Muhasebe/personel/Liste'
import MuhasebePersonelDetay from './pages/Muhasebe/personel/Detay'
import MuhasebeKasaRouter from './pages/Muhasebe/kasa'
import MuhasebeKasaListe from './pages/Muhasebe/kasa/Liste'
import MuhasebeKasaVirman from './pages/Muhasebe/kasa/Virman'
import MuhasebeKategori from './pages/Muhasebe/kategori'
import MuhasebeFatura from './pages/Muhasebe/fatura'

import MuhasebeGiderRoute from './pages/Muhasebe/gider'
import MuhasebeGider from './pages/Muhasebe/gider/gider'
import MuhasebeGiderAbonelik from './pages/Muhasebe/gider/abonelik'
import MuhasebeGiderExcel from './pages/Muhasebe/gider/excel'

import MuhasebeTahakkukRoute from './pages/Muhasebe/tahakkuk'
import MuhasebeTahakkuk from './pages/Muhasebe/tahakkuk/tahakkuk'
import MuhasebeTahakkukExcel from './pages/Muhasebe/tahakkuk/excel'

// İPTAL
import IptalRoute from './pages/Iptal/_route'
import IptalIndex from './pages/Iptal/index'
import IptalTahakkuk from './pages/Iptal/tahakkuk'
import IptalGider from './pages/Iptal/gider'
import IptalMakbuz from './pages/Iptal/makbuz'
import IptalMakbuzLog from './pages/Iptal/makbuzlog'
import IptalSayac from './pages/Iptal/sayac'
// İCRA
import IcraRoute from './pages/Icra/_route'
import IcraIndex from './pages/Icra/index'
import IcraAvukatRoute from './pages/Icra/avukat'
import IcraAvukatListe from './pages/Icra/avukat/liste'
import IcraAvukatDetay from './pages/Icra/avukat/detay'
import IcraDosyaRoute from './pages/Icra/dosya'
import IcraDosyaListe from './pages/Icra/dosya/liste'
import IcraDosyaDetay from './pages/Icra/dosya/detay'
// VEZNE
import VezneRoute from './pages/Vezne/_route'
import VezneIndex from './pages/Vezne/index'
import VezneTahsilatDetay from './pages/Vezne/Tahsilat'
import VezneOdemeDetay from './pages/Vezne/Odeme'
import VezneAbonelik from './pages/Vezne/Abonelik'
import VezneBanka from './pages/Vezne/Banka'

//RAPORLAMA
import RaporlamaRoute from './pages/Raporlama/_route'
import RaporlamaIndex from './pages/Raporlama/index'
import RaporlamaAlacak from './pages/Raporlama/alacak'
import RaporlamaBorc from './pages/Raporlama/borc'
import RaporlamaKisiHesap from './pages/Raporlama/kisihesap'
import RaporlamaCariHesap from './pages/Raporlama/carihesap'
import RaporlamaKasa from './pages/Raporlama/kasa'
import RaporlamaKasaGelir from './pages/Raporlama/kasa/gelir'
import RaporlamaKasaGider from './pages/Raporlama/kasa/gider'
import RaporlamaKasaEkstre from './pages/Raporlama/kasa/ekstre'
import RaporlamaKasaBilanco from './pages/Raporlama/kasa/bilanco'
import RaporlamaKasaAylikBilanco from './pages/Raporlama/kasa/aylik'
import RaporlamaOzel from './pages/Raporlama/ozel'
import RaporlamaOzelDefter from './pages/Raporlama/ozel/isletmedefteri'
import RaporlamaOzelGunSonu from './pages/Raporlama/ozel/gunsonu'
import RaporlamaOzelProje from './pages/Raporlama/ozel/proje'
import RaporlamaOzelDenetci from './pages/Raporlama/ozel/denetci'
import RaporlamaOzelHazirun from './pages/Raporlama/ozel/hazirun'
import RaporlamaOzelKisi from './pages/Raporlama/ozel/kisilistesi'
import RaporlamaOzelGorev from './pages/Raporlama/ozel/gorev'
import RaporlamaIcra from './pages/Raporlama/icra'
import RaporlamaIcraDosya from './pages/Raporlama/icra/dosya'
import RaporlamaIcraGecikmis from './pages/Raporlama/icra/gecikmis'
import RaporlamaSayac from './pages/Raporlama/sayac'
import RaporlamaBanka from './pages/Raporlama/banka'
import RaporlamaPos from './pages/Raporlama/webpos'
import RaporlamaSantral from './pages/Raporlama/santral'
import RaporlamaMakbuzAra from './pages/Raporlama/ozel/makbuzarama'

// İLETİŞİM
import IletisimRoute from './pages/Iletisim/_route'
import IletisimIndex from './pages/Iletisim/index'
import IletisimSmsRoute from './pages/Iletisim/sms/_route'
import IletisimSmsGonder from './pages/Iletisim/sms/gonder'
import IletisimSmsGecmis from './pages/Iletisim/sms/gecmis'
import IletisimSmsBildirim from './pages/Iletisim/sms/bildirimmerkezi'
import IletisimMail from './pages/Iletisim/mail'
import IletisimDuyuru from './pages/Iletisim/duyuru'

import SimRoute from './pages/_Sim/_route'
import SimPanel from './pages/_Sim/_/index'
import SimCari from './pages/_Sim/_/cari'
import SimCariDetay from './pages/_Sim/_/caridetay'
import SimKategori from './pages/_Sim/_/kategori'
import SimKasa from './pages/_Sim/_/kasa'

import Firsat from './pages/Firsat/index'
import Magaza from './pages/_Magaza/index'

// SPESİYAL
import KullaniciRouter from './pages/Kullanici/_route'
import Kullanici from './pages/Kullanici/index'
import KullaniciDetay from './pages/Kullanici/detay'
import Matbuu from './pages/Ekstra/matbuu'

// ÖZEL
import aidatim from './pages/_a/index'
import aidatimHesap from './pages/_a/Hesap'
import aidatimPanel from './pages/_a/Panel'
import aidatimPos from './pages/_a/Pos'
import aidatimSipay from './pages/_a/Sipay'
import aidatimSipayDetay from './pages/_a/SipayDetay'
import aidatimSms from './pages/_a/Sms'
import aidatimMail from './pages/_a/Mail'
import aidatimDestek from './pages/_a/Destek'
import aidatimFatura from './pages/_a/Fatura'
import aidatimTrack from './pages/_a/Track'

import DestekSayfa from "./components/Doc/Destek/DestekSayfa";

import web from './pages/_web/_route'

Vue.use(VueRouter);

export const router = new VueRouter({
  routes: [
    {
      path: "/giris",
      component: GirisRoute,
      children: [
        {path: "", component: GirisIndex},
        {path: "hesap", component: GirisHesap},
        {path: "parola", component: GirisParola},
        {path: "sifirla/:SifirlamaKodu", component: GirisSifirla},
        {path: "onay", component: GirisOnay}
      ],
      beforeEnter(to, from, next) {
        if (store.getters.isOturum) {
          next("/panel");
        } else {
          next();

        }
      }
    },
    {
      path: "/panel",
      component: Panel,
    },
    {
      path: "/destek",
      component: DestekSayfa,
    },
    {
      path: "/web",
      component: web,
    },
    {
      path: "/aidatim",
      component: aidatim,
      children: [
        {path: "", component: aidatimPanel},
        {path: "panel", component: aidatimPanel},
        {path: "hesap", component: aidatimHesap},
        {path: "sms", component: aidatimSms},
        {path: "mail", component: aidatimMail},
        {path: "pos", component: aidatimPos},
        {path: "sipay", component: aidatimSipay},
        {path: "sipaydetay", component: aidatimSipayDetay},
        {path: "destek", component: aidatimDestek},
        {path: "fatura", component: aidatimFatura},
        {path: "track", component: aidatimTrack},
      ]
    },

    {
      path: "/yonetim",
      component: YonetimRoute,
      children: [
        {path: "", component: YonetimIndex},
        {
          path: "sirket", component: YonetimSirketRoute,
          children: [
            {path: "", component: YonetimSirketIndex},
            {path: "teklif", component: YonetimSirketTeklif},
            {path: "meskenturu", component: YonetimSirketMeskenTuru},
          ]
        },
        {
          path: "site", component: YonetimBinaRoute,
          children: [
            {path: "", component: YonetimBinaListe},
            {path: ":Bina_id", component: YonetimBinaDetay, props: true}
          ]
        },
        {
          path: "bina", component: YonetimBinaRoute,
          children: [
            {path: "", component: YonetimBinaListe},
            {path: ":Bina_id", component: YonetimBinaDetay, props: true}
          ]
        },
        {
          path: "mesken", component: YonetimMeskenRoute,
          children: [
            {path: "", component: YonetimMeskenListe},
            {path: ":Mesken_id", component: YonetimMeskenDetay, props: true}
          ]
        },
        {
          path: "kisi", component: YonetimKisiRoute,
          children: [
            {path: "", component: YonetimKisiListe},
            {path: ":Kisi_id", component: YonetimKisiDetay, props: true}
          ]
        },
      ],
    },
    {
      path: "/vezne",
      component: VezneRoute,
      children: [
        {path: "", component: VezneIndex},
        {path: "abonelik", component: VezneAbonelik},
        {path: "banka", component: VezneBanka},
        {
          path: "tahsilat", component: VezneTahsilatDetay,
          children: [
            {path: "", component: VezneTahsilatDetay},
            {path: ":Kisi_id", component: VezneTahsilatDetay, props: true},
          ]
        },
        {
          path: "odeme", component: VezneOdemeDetay,
          children: [
            {path: "", component: VezneOdemeDetay},
            {path: ":Cari_id", component: VezneOdemeDetay, props: true},
            {path: ":Cari_id/:Bina_id", component: VezneOdemeDetay, props: true},
          ]
        },

      ]
    },
    {
      path: "/muhasebe",
      component: MuhasebeRoute,
      children: [
        {path: "", component: MuhasebeIndex},
        {
          path: "cari", component: MuhasebeCariRoute,
          children: [
            {path: "", component: MuhasebeCariListe},
            {path: ":Cari_id", component: MuhasebeCariDetay, props: true},
          ]
        },
        {
          path: "personel", component: MuhasebePersonelRoute,
          children: [
            {path: "", component: MuhasebePersonelListe},
            {path: ":Personel_id", component: MuhasebePersonelDetay, props: true},
          ]
        },
        {
          path: "kasa", component: MuhasebeKasaRouter,
          children: [
            {path: "", component: MuhasebeKasaListe},
            {path: "virman", component: MuhasebeKasaVirman},
          ]
        },
        {path: "fatura", component: MuhasebeFatura},
        {path: "kategori", component: MuhasebeKategori},
        {path: "gelir", component: MuhasebeGider},
        {path: "meskenturu", component: YonetimSirketMeskenTuru},
        {
          path: "gider", component: MuhasebeGiderRoute,
          children: [
            {path: "", component: MuhasebeGider},
            {path: "gider", component: MuhasebeGider},
            {path: "abonelik", component: MuhasebeGiderAbonelik},
            {path: "excel", component: MuhasebeGiderExcel},
          ]
        },
        {
          path: "tahakkuk", component: MuhasebeTahakkukRoute,
          children: [
            {path: "", component: MuhasebeTahakkuk},
            {path: "tahakkuk", component: MuhasebeTahakkuk},
            {path: "excel", component: MuhasebeTahakkukExcel},
          ]
        },
      ]
    },
    {
      path: "/raporlama",
      component: RaporlamaRoute,
      children: [
        {path: "", component: RaporlamaIndex},
        {path: "alacak", component: RaporlamaAlacak},
        {path: "borc", component: RaporlamaBorc},
        {path: "kisi", component: RaporlamaKisiHesap},
        {path: "cari", component: RaporlamaCariHesap},
        {
          path: "kasa", component: RaporlamaKasa,
          children: [
            {path: "gelir", component: RaporlamaKasaGelir},
            {path: "gider", component: RaporlamaKasaGider},
            {path: "ekstre", component: RaporlamaKasaEkstre},
            {path: "bilanco", component: RaporlamaKasaBilanco},
            {path: "aylik", component: RaporlamaKasaAylikBilanco},
          ]
        },
        {
          path: "ozel", component: RaporlamaOzel,
          children: [
            {path: "defter", component: RaporlamaOzelDefter},
            {path: "gunsonu", component: RaporlamaOzelGunSonu},
            {path: "proje", component: RaporlamaOzelProje},
            {path: "denetci", component: RaporlamaOzelDenetci},
            {path: "hazirun", component: RaporlamaOzelHazirun},
            {path: "kisi", component: RaporlamaOzelKisi},
            {path: "gorev", component: RaporlamaOzelGorev},
            {path: "makbuz", component: RaporlamaMakbuzAra},
          ]
        },
        {
          path: "icra", component: RaporlamaIcra,
          children: [
            {path: "dosya", component: RaporlamaIcraDosya},
            {path: "gecikmis", component: RaporlamaIcraGecikmis}
          ]
        },
        {path: "sayac", component: RaporlamaSayac},
        {path: "banka", component: RaporlamaBanka},
        {path: "webpos", component: RaporlamaPos},
        {path: "santral", component: RaporlamaSantral},
      ]
    },
    {
      path: "/icra",
      component: IcraRoute,
      children: [
        {path: "", component: IcraIndex},
        {
          path: "avukat", component: IcraAvukatRoute,
          children: [
            {path: "", component: IcraAvukatListe},
            {path: ":Avukat_id", component: IcraAvukatDetay, props: true},
          ]
        }, {
          path: "dosya", component: IcraDosyaRoute,
          children: [
            {path: "", component: IcraDosyaListe},
            {path: ":Kisi_id", component: IcraDosyaDetay, props: true},
          ]
        },
      ]
    },
    {
      path: "/sim",
      component: SimRoute,
      children: [
        {path: "", component: SimPanel},
        {path: "panel", component: SimPanel},
        {
          path: "cari", component: SimCari,
          children: [
            {path: "", component: SimCari},
            {path: ":Cari_id", component: SimCariDetay}
          ],
        },
        {path: "kasa", component: SimKasa},

      ]
    },
    // {
    //   path: "/firsat",
    //   component: Firsat
    // },
    // {
    //   path: "/magaza",
    //   component: Magaza
    // },
    {
      path: "/iletisim",
      component: IletisimRoute,
      children: [
        {path: "", component: IletisimIndex},
        {
          path: "sms", component: IletisimSmsRoute,
          children: [
            {path: "", component: IletisimSmsGonder},
            {path: "gecmis", component: IletisimSmsGecmis},
            {path: "bildirim", component: IletisimSmsBildirim},
          ]
        },
        {path: "mail", component: IletisimMail},
        {path: "duyuru", component: IletisimDuyuru},
      ]
    },
    {
      path: "/iptal",
      component: IptalRoute,
      children: [
        {path: "", component: IptalIndex},
        {path: "tahakkuk", component: IptalTahakkuk},
        {path: "gider", component: IptalGider},
        {path: "gelir", component: IptalGider},
        {path: "makbuz", component: IptalMakbuz},
        {path: "makbuzlog", component: IptalMakbuzLog},
        {path: "sayac", component: IptalSayac}
      ]
    },
    {
      path: "",
      component: Panel,
    },
    {
      path: "/kullanici",
      component: KullaniciRouter,
      children: [
        {path: "", component: Kullanici},
        {path: ":Kullanici_id", component: KullaniciDetay, props: true}
      ],
    },
    {
      path: "/matbuu",
      component: Matbuu,
    },
    {
      path: "/403",
      component: Yetkisiz,
    },
    {
      path: "*",
      component: SayfaYok,
    }

  ],
  mode: "history"
});



// WEBPACK FOOTER //
// ./src/router.js